module.exports = __webpack_public_path__ + "./Justin_pbw_01a17d96831e5b4390aa2f90778185b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Justin_pbw.png
// module id = 591
// module chunks = 0